<template>
  <div class="container mt-5">
    <div class="text-center verification-success">
      <div v-if="user && user.firstName" class="mb-4">
        <h1>Welcome, {{ user.firstName }}!</h1>
      </div>
      <svg class="success-icon" viewBox="0 0 16 16">
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
      </svg>
      <h2 class="mt-4">Email Verified Successfully!</h2>
      <p class="lead mt-3">Thank you for verifying your email address. Your account is now fully activated.</p>

      <!-- Premium Upgrade Section -->
      <div class="premium-promotion mt-5 mb-4">
        <div class="premium-card">
          <div class="premium-header">
            <i class="mdi mdi-crown premium-icon"></i>
            <h3 class="premium-title">Sign up for a Premium Account to access all HuntApply perks</h3>
          </div>
          <p class="premium-description">
            
          </p>
          <div class="premium-features mb-4">
            <div class="row">
              <div class="col-md-6">
                <div class="feature-item">
                  <i class="mdi mdi-check-circle text-success"></i>
                  <span>Save your draw points and see your odds for every hunt</span>
                </div>
                <div class="feature-item">
                  <i class="mdi mdi-check-circle text-success"></i>
                  <span>Priority customer support</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="feature-item">
                  <i class="mdi mdi-check-circle text-success"></i>
                  <span>Convenient, detailed state hunt bio information</span>
                </div>
                <div class="feature-item">
                  <i class="mdi mdi-check-circle text-success"></i>
                  <span>Advanced mapping features</span>
                </div>
              </div>
            </div>
          </div>
          <div class="premium-pricing mb-4">
            <span class="price">$20</span>
            <span class="period">/year</span>
          </div>
          <button @click="showPremiumUpgrade" class="btn btn-premium btn-lg">
            <i class="mdi mdi-crown me-2"></i>
            Upgrade to Premium Now
          </button>
          <p class="premium-note mt-2">
            <small>Secure payment powered by Stripe</small>
          </p>
        </div>
      </div>

      <div class="navigation-buttons mt-4">
        <button @click="showPremiumUpgrade" class="btn btn-outline-primary btn-lg me-3">
          <i class="mdi mdi-crown me-2"></i>
          Get Premium
        </button>
        <router-link to="/" class="btn btn-primary btn-lg">
          <i class="mdi mdi-home me-2"></i>
          Explore Free Features
        </router-link>
      </div>

      <!-- Success Message -->
      <div v-if="upgradeSuccessMessage" class="alert alert-success mt-4">
        {{ upgradeSuccessMessage }}
      </div>

      <!-- Premium Upgrade Modal -->
      <PremiumUpgrade
        v-if="showUpgradeModal"
        @close="closeUpgradeModal"
        @upgrade-success="handleUpgradeSuccess"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PremiumUpgrade from './PremiumUpgrade.vue';

export default {
  name: 'EmailVerified',
  components: {
    PremiumUpgrade,
  },
  data() {
    return {
      showUpgradeModal: false,
      upgradeSuccessMessage: null,
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
  },
  created() {
    // Set expiration to 24 hours from now
    const expiration = new Date();
    expiration.setHours(expiration.getHours() + 24);
    
    this.fetchUserData();
    console.log("Logging user in");
    this.login(expiration.toISOString());

  },
  methods: {
    ...mapActions(['setUser', 'login']),
    async fetchUserData() {
      try {
        const response = await fetch(this.$API_BASE_URL + '/api/customers/whoami', {
          method: 'GET',
          credentials: "include", // Ensures cookies are sent with the request
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          this.setUser(data);
          console.log("User data fetched successfully:", data);
        } else {
          console.error('Failed to fetch user information');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    },

    showPremiumUpgrade() {
      this.showUpgradeModal = true;
    },

    closeUpgradeModal() {
      this.showUpgradeModal = false;
    },

    handleUpgradeSuccess() {
      this.showUpgradeModal = false;
      this.upgradeSuccessMessage = 'Congratulations! You have successfully upgraded to Premium. You now have access to all premium features.';
      
      // Update user's premium status in the store if needed
      if (this.$store && this.$store.commit) {
        this.$store.commit('updatePremiumStatus', true);
      }
    },
  }
}
</script>

<style scoped>
.verification-success {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.success-icon {
  width: 4rem;
  height: 4rem;
  color: #28a745;
}

.lead {
  color: #6c757d;
}

.btn-primary {
  padding: 0.75rem 2rem;
  font-size: 1.1rem;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Premium Promotion Styles */
.premium-promotion {
  margin: 3rem 0;
}

.premium-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 2.5rem;
  color: white;
  text-align: center;
  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.4);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  overflow: hidden;
}

.premium-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
  0%, 100% { transform: rotate(0deg); }
  50% { transform: rotate(180deg); }
}

.premium-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 60px rgba(102, 126, 234, 0.5);
}

.premium-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 1;
}

.premium-icon {
  font-size: 2.5rem;
  color: #ffd700;
  margin-right: 0.75rem;
  animation: bounce 2s ease-in-out infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-10px); }
  60% { transform: translateY(-5px); }
}

.premium-title {
  color: white;
  margin: 0;
  font-weight: 700;
  font-size: 1.75rem;
}

.premium-description {
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 2rem;
  font-size: 1.1rem;
  line-height: 1.6;
  position: relative;
  z-index: 1;
}

.premium-features {
  text-align: left;
  max-width: 500px;
  margin: 0 auto 2rem;
  position: relative;
  z-index: 1;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 500;
}

.feature-item i {
  margin-right: 1rem;
  font-size: 1.25rem;
  color: #4ade80;
  flex-shrink: 0;
}

.feature-item span {
  color: rgba(255, 255, 255, 0.95);
}

.premium-pricing {
  margin-bottom: 2rem;
  position: relative;
  z-index: 1;
}

.price {
  font-size: 3.5rem;
  font-weight: bold;
  color: #ffd700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.period {
  font-size: 1.5rem;
  color: rgba(255, 255, 255, 0.8);
  margin-left: 0.5rem;
}

.btn-premium {
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  border: none;
  color: #1a202c;
  font-weight: 700;
  padding: 1rem 2.5rem;
  border-radius: 12px;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(255, 215, 0, 0.4);
  position: relative;
  z-index: 1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-premium:hover {
  background: linear-gradient(135deg, #ffed4e 0%, #ffd700 100%);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(255, 215, 0, 0.5);
  color: #1a202c;
}

.btn-premium:active {
  transform: translateY(-1px);
}

.premium-note {
  color: rgba(255, 255, 255, 0.7);
  margin-top: 1rem;
  position: relative;
  z-index: 1;
}

.navigation-buttons {
  margin: 2rem 0;
}

.navigation-buttons .btn {
  margin: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 768px) {
  .verification-success {
    padding: 1.5rem;
  }
  
  .premium-card {
    padding: 2rem 1.5rem;
  }
  
  .premium-icon {
    font-size: 2rem;
  }
  
  .premium-title {
    font-size: 1.5rem;
  }
  
  .price {
    font-size: 2.5rem;
  }
  
  .btn-premium {
    padding: 0.875rem 2rem;
    font-size: 1.1rem;
  }
  
  .navigation-buttons .btn {
    display: block;
    width: 100%;
    margin: 0.5rem 0;
  }
  
  .premium-features {
    text-align: center;
  }
  
  .feature-item {
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .premium-card {
    padding: 1.5rem 1rem;
  }
  
  .premium-title {
    font-size: 1.25rem;
  }
  
  .price {
    font-size: 2rem;
  }
  
  .period {
    font-size: 1.2rem;
  }
}
</style>
